"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wait = exports.WaitConfiguration = exports.WaitFooter = exports.useWaitFor = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
const ElementReferenceFields_1 = require("../../editor/ElementReferenceFields");
const types_1 = require("../../types");
const StepNavigation_1 = require("../StepNavigation");
const WaitForSelect_1 = require("../WaitForSelect");
function useWaitFor(element, waitFor, callback) {
    react_2.default.useEffect(() => {
        const handle = setInterval(() => {
            const el = document.querySelector(element.selector);
            let hasElement = !!el;
            if (el) {
                hasElement = window.getComputedStyle(el).getPropertyValue('opacity') !== '0';
            }
            if (hasElement && waitFor === types_1.WaitFor.Appear) {
                callback();
                clearInterval(handle);
            }
            else if (!hasElement && waitFor === types_1.WaitFor.Disappear) {
                callback();
                clearInterval(handle);
            }
        }, 500);
        return () => clearInterval(handle);
    }, [element]);
}
exports.useWaitFor = useWaitFor;
function WaitFooter({ step, onUpdateStep }) {
    useWaitFor(step.element, step.waitFor, () => {
        onUpdateStep(1);
    });
    return react_2.default.createElement(StepNavigation_1.StepNavigation, { onUpdateStep: onUpdateStep, loading: true, disabled: true });
}
exports.WaitFooter = WaitFooter;
function WaitConfiguration({ prefix }) {
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(ElementReferenceFields_1.ElementReferenceFields, { prefix: `${prefix}.element`, required: true }),
        react_2.default.createElement(react_1.Form.Item, { name: `${prefix}.waitFor`, label: 'Wait for', required: { value: true, message: 'A wait for is required.' } },
            react_2.default.createElement(WaitForSelect_1.WaitForSelect, null))));
}
exports.WaitConfiguration = WaitConfiguration;
exports.Wait = {
    label: 'Wait',
    renderConfiguration: WaitConfiguration,
    renderFooter: WaitFooter,
};
//# sourceMappingURL=Wait.js.map